<div class="med-table">
  <table
    class="med-table__table"
    cellspacing="0"
  >
    <thead
      *ngIf="settingsLocal.visibleHead"
      [style.position]="settingsLocal.sticky ? 'sticky' : 'initial'"
      [style.top]="settingsLocal.stickyTop"
      class="med-table__thead"
    >
      <tr class="med-table__tr">
        <th
          *ngIf="settingsLocal.expand"
          class="med-table__th expand"
        ></th>

        <th
          *ngFor="let column of columns | async; let tdIndex = index"
          class="med-table__th"
          [class.med-table__sticky-delimiter]="isVisibleStickyDelimiter(tdIndex)"
          [hidden]="column.headCellColspan | isCellHidden"
          [attr.colspan]="column.headCellColspan || settingsLocal.colspan"
          [style.minWidth]="column | getCellMinWidth : settingsLocal"
          [style.maxWidth]="column | getCellMaxWidth : settingsLocal"
          [style.position]="column.fixed ? 'sticky' : 'initial'"
          [style.zIndex]="column.fixed ? '1' : 'initial'"
          [style.left]="column | getCellLeft : columns.getValue() : settingsLocal"
        >
          <med-table-head-cell
            [column]="column"
            [templates]="templatesLocal"
            [sort]="sortLocal"
            [medE2eTestId]="column.label"
            (sortChange)="onSortChange($event)"
          ></med-table-head-cell>
        </th>
      </tr>
    </thead>

    <tbody class="med-table__tbody">
      <ng-container *ngFor="let row of data$ | async; let i = index">
        <tr
          [ngClass]="[settingsLocal.rowDataClass, settingsLocal.rowDataClassFn(row, i)]"
          class="med-table__tr"
        >
          <td
            *ngIf="settingsLocal.expand"
            class="med-table__td expand"
            medE2eTestId="expand"
          >
            <med-btn
              mode="icon"
              size="small"
              skin="text"
              [rounded]="true"
              (click)="expandToggle(i)"
            >
              <med-icon-chevron-down
                size="16"
                class="med-table__icon"
                [ngClass]="{ 'rotate-up': row | visibleExpandRow }"
              ></med-icon-chevron-down>
            </med-btn>
          </td>

          <td
            *ngFor="let column of columns | async; let tdIndex = index"
            class="med-table__td"
            [class.med-table__sticky-delimiter]="isVisibleStickyDelimiter(tdIndex)"
            [hidden]="column.dataCellColspan | isCellHidden"
            [attr.colspan]="column.dataCellColspan || settingsLocal.colspan"
            [style.minWidth]="column | getCellMinWidth : settingsLocal"
            [style.maxWidth]="column | getCellMaxWidth : settingsLocal"
            [style.position]="column.fixed ? 'sticky' : 'initial'"
            [style.zIndex]="column.fixed ? '1' : 'initial'"
            [style.left]="column | getCellLeft : columns.getValue() : settingsLocal"
          >
            <med-table-cell
              [index]="i"
              [column]="column"
              [data]="row"
              [settings]="settingsLocal"
              [templates]="templatesLocal"
              [medE2eTestId]="column.label"
            ></med-table-cell>
          </td>
        </tr>

        <tr
          *ngIf="settingsLocal.expand && (row | visibleExpandRow)"
          class="med-table__tr"
        >
          <td
            [colSpan]="columns.value.length + 1"
            class="med-table__td"
          >
            <ng-container
              *ngIf="expandTemplate"
              [ngTemplateOutlet]="expandTemplate"
              [ngTemplateOutletContext]="{ $implicit: row, index: i }"
            ></ng-container>
          </td>
        </tr>
      </ng-container>

      <tr
        *ngIf="!(data$ | async)?.length"
        class="med-table__tr"
      >
        <td
          class="med-table__td med-table__empty-message"
          [attr.colspan]="(columns | async)?.length"
          medE2eTestId="emptyMessage"
        >
          {{ settingsLocal.emptyMessage }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
